import styles from "../item/Item.module.css";
import type ItemProperties from "./Item.properties.ts";

export default function ItemView(props: ItemProperties) {
  return (
    <div
      className={`${styles.itemContainer} ${props.market.id?.toString() === props.selectedValue ? styles["selected"] : ""}`}
      onClick={() => props.onChange(props.market)}
    >
      {props.market.name}
    </div>
  );
}
